import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { HexagonalUtils } from '../../../jscaip/HexagonalUtils';
import { PlayerNumberMap } from '../../../jscaip/PlayerMap';
import { TriangularCheckerBoard } from '../../../jscaip/state/TriangularCheckerBoard';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractGoRules } from '../AbstractGoRules';
import { TriangularGoGroupDataFactory } from '../GoGroupDataFactory';
import { GoPhase } from '../GoPhase';
import { GoPiece } from '../GoPiece';
import { GoState } from '../GoState';
export class TriangularGoRules extends AbstractGoRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Standard`,
        config: {
            size: new NumberConfig(7, RulesConfigDescriptionLocalizable.SIZE, MGPValidators.range(1, 99)),
            hexagonal: new BooleanConfig(false, () => $localize `Hexagonal`),
        },
    });
    static get() {
        if (TriangularGoRules.singleton.isAbsent()) {
            TriangularGoRules.singleton = MGPOptional.of(new TriangularGoRules());
        }
        return TriangularGoRules.singleton.get();
    }
    constructor() {
        super(false);
    }
    getInitialState(config) {
        const size = config.size;
        let board;
        if (config.hexagonal) {
            board = HexagonalUtils.createBoard(size, GoPiece.UNREACHABLE, GoPiece.EMPTY);
        }
        else {
            board = TriangularCheckerBoard.createBoard(size, GoPiece.UNREACHABLE, GoPiece.EMPTY);
        }
        return new GoState(board, PlayerNumberMap.of(0, 0), 0, MGPOptional.empty(), GoPhase.PLAYING);
    }
    getRulesConfigDescription() {
        return TriangularGoRules.RULES_CONFIG_DESCRIPTION;
    }
    getGoGroupDataFactory() {
        return new TriangularGoGroupDataFactory();
    }
}
